import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-enquiry',
  templateUrl: './edit-enquiry.component.html',
  styleUrls: ['./edit-enquiry.component.scss']
})
export class EditEnquiryComponent implements OnInit {

  @Input() caseId: number = -1;
  @Input() enquiryId: number = -1;
  @Input() enquiry?: any;

  editEnquiry = this.fb.group({
    caseId: null,
    enquiry: ''
  }, {});

  constructor(
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
  ) {
    

  }

  ngOnInit(): void {
    this.editEnquiry.controls["caseId"].setValue(this.caseId);
    this.editEnquiry.controls["enquiry"].setValue(this.enquiry);
  }

  save() {
    this.activeModal.close(this.editEnquiry.value.enquiry);
  }

  close() {
    this.activeModal.dismiss(null);
  }

}
